import { SET_CHRISTMAS_GIFT } from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";

export const giftStatus = createReducer({present_confirmed: null}, {
    [SET_CHRISTMAS_GIFT]: (state, payload)=> payload
});

